/**
 * Dynamic Third-Party App & Script Lazy Loader + Image Hotfix
 * Optimizes mobile performance by delaying the loading of heavy, non-critical scripts 
 * until the user interacts with the page or a timeout occurs, and hotfixes missing lazyload classes.
 */

(function() {
  // ==========================================
  // 1. IMMEDIATE IMAGE LAZYLOAD HOTFIX
  // Runs as soon as DOM is ready to prevent blank images
  // ==========================================
  function hotfixLazyImages() {
    console.log('[Performance Optimizer] Running image lazyload class hotfix...');
    const selector = 'img[data-src]:not(.lazyload), img[data-srcset]:not(.lazyload)';
    const brokenImages = document.querySelectorAll(selector);
    
    brokenImages.forEach(img => {
      img.classList.add('lazyload');
    });
    
    // If lazySizes is already initialized, tell it to check for new elements
    if (window.lazySizes && typeof lazySizes.init === 'function') {
      lazySizes.init();
    }
  }

  // Run hotfix immediately if DOM is already loaded, otherwise bind it
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hotfixLazyImages);
  } else {
    hotfixLazyImages();
  }

  // Also run hotfix dynamically when new content is loaded or dynamically inserted
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length > 0) {
        shouldRun = true;
      }
    });
    if (shouldRun) {
      hotfixLazyImages();
    }
  });
  
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  // ==========================================
  // 2. THIRD-PARTY SCRIPT DEFERRAL
  // Delays loading of heavy SDKs and widgets
  // ==========================================
  const thirdPartyScripts = [
    {
      name: 'Judge.me Preloads',
      src: 'https://cdn.judge.me/widget_preloads.js',
      type: 'script'
    },
    {
      name: 'Facebook Pixel SDK',
      src: 'https://connect.facebook.net/en_US/fbevents.js',
      type: 'script',
      callback: function() {
        if (window.fbq) {
          fbq('init', 'YOUR_PIXEL_ID'); // Replace with actual Pixel ID
          fbq('track', 'PageView');
        }
      }
    }
  ];

  let scriptsLoaded = false;

  function loadAllScripts() {
    if (scriptsLoaded) return;
    scriptsLoaded = true;

    // Clean up event listeners
    window.removeEventListener('scroll', loadAllScripts);
    window.removeEventListener('touchstart', loadAllScripts);
    window.removeEventListener('mousemove', loadAllScripts);
    window.removeEventListener('click', loadAllScripts);

    console.log('[Performance Optimizer] Loading third-party scripts...');

    thirdPartyScripts.forEach(script => {
      if (script.type === 'script') {
        const s = document.createElement('script');
        s.src = script.src;
        s.async = true;
        
        if (script.callback) {
          s.onload = script.callback;
        }
        
        document.body.appendChild(s);
      }
    });

    // Fire custom event to notify other sections
    const event = new CustomEvent('performance:scriptsloaded');
    document.dispatchEvent(event);
  }

  // Bind interaction listeners
  window.addEventListener('scroll', loadAllScripts, { passive: true });
  window.addEventListener('touchstart', loadAllScripts, { passive: true });
  window.addEventListener('mousemove', loadAllScripts, { passive: true });
  window.addEventListener('click', loadAllScripts, { passive: true });

  // Safety fallback: load scripts anyway if no interaction within 6 seconds
  setTimeout(loadAllScripts, 6000);
})();
